import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const PricingBreadcrumb = () => {
    return (
        <>
            <Breadcrumb title="Our" subTitle="Package" smText=" Price Table"></Breadcrumb>
        </>
    );
};

export default PricingBreadcrumb;